import React from 'react';
import lax from 'lax.js';
 
class About extends React.Component {
    
    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }

    render(){
        return (
            <section className="about-area ptb-120 bg-image">
                <div className="container">
                    <div className="row h-100 align-items-center">
                        <div className="col-lg-6">
                            <div className="about-content">
                                <span>Inscríbete al congreso</span>
                                <h2>Educación orgánica, creando conexiones</h2>
                                <p>Descubre una forma de entender la Educación como algo “orgánico”, en cuyo centro está la la persona, con su originalidad. Una educación que integra y crea conexiones hacia dentro, y hacia fuera. Esta es la que inspira el modelo pedagógico vivo y en crecimiento (MPK), compartido por una amplia red internacional de colegios muy distintos entre sí, pero con una mirada común sobre la Educación y la Persona. Y comprueba cómo esta mirada dialoga, se concreta y enriquece, a través de diversas iniciativas pedagógicas, propias y externas. 
                                    </p> 
                                <p>Habrá ponencias, mesas redondas, talleres, aulas vivas, momentos de encuentro, acompañamiento musical, visita de autoridades y áreas de exposición. 
                                    </p> 
                                <p>Participará, por supuesto, la Red de Colegios de Schoenstatt (España, Portugal, Chile, México, Argentina, Uruguay, Ecuador y Brasil) dentro de la Semana Internacional 2022. Pero está dirigido a colegios e instituciones educativas (equipos directivos, formadores, profesores y estudiantes de universidades de Educación) y está abierto a toda persona o profesional del ámbito educativo que estén interesados en los temas a tratar. 
                                    </p>


                                {/* <Link to="/#" className="btn btn-primary">
                                    Leer más  
                                    <i className="icofont-double-right"></i>
                                </Link> */}

                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="about-image">
                                <img src={require("../../assets/images/fundacion.jpg")} className="about-img1" alt="about" />

                                {/* <img src={require("../../assets/images/about2.jpg")} className="about-img2" alt="about" /> */}

                                {/* <img src={require("../../assets/images/shapes/5.png")} className="shape-img" alt="about" /> */}

                            </div>
                        </div>
                    </div>


                <div className="row h-100 align-items-center" style={{"margin-top":"60px"}}>
                        <div className="col-6">
                            <div className="about-image">
                                <img src={require("../../assets/images/trabajo equipo.jpg")} className="about-img2" alt="about" />

                            </div>
                            <div className='links-about'>

                                <p> 
                                <a href="https://tiemposmasnuevos.org/">Tiempos más nuevos</a>
                                </p>
                                <p> 
                                <a href="https://www.colegiomontetabor.es/">Colegio Monte Tabor</a>
                                </p>
                                <p> 
                                <a href="https://www.pentecostes.cl/">Fundación Pentecostés</a>
                                </p>
                            </div>

                        </div>


                        <div className="col-lg-6">
                            <div className="about-content">
                                <span>Conócenos</span>
                                <h2>Nosotros</h2>
                                <p>
                                El Colegio Monte Tabor Schoenstatt somos un colegio concertado católico, con un especial interés en la integración, que abrió sus puertas en 2006, en Pozuelo de Alarcón, Madrid, como proyecto educativo de la Fundación Tiempos Más Nuevos. Ambos forman parte del Movimiento Apostólico de Schoenstatt en España. 
                                </p>
                                <p>
                                El carisma del movimiento, sin tener una misión explícitamente educativa, ha suscitado la creación de muchos colegios y espacios de formación de la persona. Sin colegios muy diversos, que dan respuesta en circunstancias diversas, pero que comparten este concepto de la pedagogía, que fue muy visionario en sus orígenes (mediados del s.XX) y muy avalado en todo su recorrido hasta la actualidad. Una pedagogía que habla de la libertad, los ideales, la confianza, el movimiento...y sobre todo, tiene claro el modelo de hombre y sociedad que busca, cuáles son las necesidades del hombre y el mundo de hoy. Es esa pedagogía orgánica que queremos dar a conocer. 
                                </p>
                                <p>
                                La Fundación Pentecostés, se pone al servicio de esta realidad, y de todos estos colegios. De su labor destacamos la iniciativa de crear una red internacional de colegios kentenijianos, que nos ha permitido reconocernos y enriquecernos, y la de concretar un modelo pedagógico común que es el M.P.K. y conseguir respaldarlo desde el trabajo académico y científico y aterrizar la pedagogía de Schoenstatt al ámbito docente. Ahora, de la mano, nos animamos a compartirlo con el resto de la comunidad educativa, sin límites de fronteras y realidades. 
                                </p>
                                <p>
                                Como colegio, creemos firmemente que, después de estos 16 años de rodaje, debemos compartir lo que tenemos. Nuestro proyecto educativo es algo vivo, y aunque se ha ido consolidando como un proyecto de calidad, destacable en varios aspectos, debe seguir creciendo y adaptándose a los nuevos desafíos. Como creemos debe hacerlo cualquier institución educativa. Por eso, queremos invitaros no sólo a conocernos, conocer el modelo MPK, sino, invitar a expertos, profesionales e instituciones del mundo educativo, para compartir reflexiones, ideas nuevas y encontrar espacios de diálogo y crecimiento mutuo. 
                                </p>

                            </div>
                        </div>

                        
                </div>
            </div>

            </section>
        );
    }
}
 
export default About;